import { Router } from "@reach/router";
import Main from "./Components/Main";
import Success from "./Components/Success";
import SubDomainRouter from "./Components/SubDomainRouter";
import React, {  Suspense } from 'react';

export default function AppRouter() {
  return (
      <Suspense fallback={'Loading ...'}>
    <Router>
      <Main path="/" default>
        <SubDomainRouter path="/" default />
        <Success path="/Success" />
      </Main>
    </Router>
      </Suspense>
  );
}
